



















import { Component, Prop, Vue, Ref } from 'vue-property-decorator'

@Component
export default class SetPassword extends Vue {
  @Prop(String)
  private email!: string

  @Prop(String)
  private token!: string
}
